.da{user-select:none;}